import React from "react";
import def from "../../img/users/def.png";
import {Link} from "react-router-dom";
import FollowFunc from "../../Utilits/Follow";
const User = ({img, name, status, id, follow, followed, unFollow, waitingSubscripe, page}) => {
    return(
        <div className="users__card">
            <div className="users__card-front">
                <div className='users__avatar-user'><Link to={'profile/' + id}><img src={img ? img : def} alt=""/></Link></div>
                <div className="main-text"><p>{name}</p></div>
                <div className="additional-text"><p>{status ? status : "Статус отсутствует"}</p></div>
                {followed ?
                    <div className="normal-button users__follow-on-you">
                        <p>Вы подписаны на него</p>
                    </div> :
                    <div className="users__unfollow-on-you normal-button">
                        <p>Вы не подписаны на него</p>
                    </div>
                }
            </div>
            <div className={page === "users" ? "users__card-back" : "users__card-back friends__card-back"}>
                <div className='users__action-on-user'>
                    <div className='users__buttons'>
                        <div className="users__normal-button_first normal-button"><button>Отправить сообщение</button></div>
                        <FollowFunc id={id} component='users' followed={followed} follow={follow} unFollow={unFollow} waitingSubscripe={waitingSubscripe}/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default User